export const isHttpStatusError = (error: Error, status: number) => {
    if (typeof error !== 'object' || error === null || !('response' in error)) {
        return false;
    }

    const { response } = error as { response?: { status?: number } };

    return response?.status === status;
};
